module.exports = __webpack_public_path__ + "static/media/Energy.9576737f.svg";